import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import {OtherActivityDetails} from './otherActiviteDetails';
import { FrenchTypes } from '../../../../../../../constants/utils/connectionTypes';

export const OtherActivity = ({userId, serviceDatas, disableModifications, generateLetters}) => {

    const [activityState, setActivityState] = useState({
        items: []
    });

    useEffect(() => {
        let activitiesInState = serviceDatas.filter(s => s.serviceType === FrenchTypes.otherActivity);
        if (activitiesInState.length > 0){
            setActivityState({
                items: activitiesInState
            });
        }else{
            setActivityState({...activityState, items: [{}]});
        }
    }, [serviceDatas]);

    function removeActivity(activity) {
        setActivityState({...activityState, items: activityState.items.filter(a => a !== activity)});
    }

    return (
        <article className="block" id="autre activité">
            <h3 className="sr-only visually-hidden">autre activité</h3>
            {
                activityState.items.map((activity, index) => {
                    return <OtherActivityDetails key={index} index={index} userId={userId} activity={activity} removeActivity={removeActivity} disableModifications={disableModifications} generateLetters={generateLetters} />
                })
                    
            }

            <footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center bg-light pt-4 pb-1">
                <h4 className="sr-only visually-hidden">Ajouter une autre ACTIVITÉ</h4>
                <button type="button" className="btn btn-icon btn-alert-info mx-auto py-2" disabled={activityState.items.findIndex(item => JSON.stringify(item) === JSON.stringify({})) !== -1} onClick={(e) => {
                    const nodes = window.document.querySelectorAll('.collapse.show');
                    if (!R.isNil(nodes) && nodes.length > 0) {
                        nodes.forEach(element => {
                            element.classList.remove(['show']);
                        });
                    }
                    setActivityState({ ...activityState, items: activityState.items.concat({}) });
                }}>
                    <i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter une autre ACTIVITÉ
				</button>
            </footer>
        </article>
    )
}